import React from 'react';
import { Spin, Table, Descriptions } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { useReportsStore } from '../../store/slices/createReportsSlice';

function ReferralReport() {

    const general = useGeneralStore();
    const reports = useReportsStore()
    const data = reports.referral.data?.Items;
    const referrer = reports.referral.data?.Referrer;
    const hasReferrer = Boolean(referrer && (referrer.FullName || referrer.UserName));
    const loading = reports.referral.loading;

    const columns = [
        {
            title: "نام بیمه گزار",
            dataIndex: "FullName",
            key: "FullName",
            width: 130,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.FullName ? first = a.FullName : first = '';
                b.FullName ? second = b.FullName : second = '';
                return first.localeCompare(second)
            },
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>
        },
        {
            title: "نام کاربری",
            dataIndex: "UserName",
            key: "UserName",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.UserName ? (first = a.UserName) : (first = "");
                b.UserName ? (second = b.UserName) : (second = "");
                return first.localeCompare(second);
            },
            render: text => text && strings.getFarsiNum(text),
        },

        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            width: 130,
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },

    ];
    return (
        <Spin spinning={loading} >
            {hasReferrer ?
                <div className="user-report" style={{ marginBottom: 16 }}>
                    <Descriptions
                        title="معرف"
                        bordered
                        size="small"
                        column={2}
                    >
                        <Descriptions.Item label="نام و نام خانوادگی">{referrer.FullName || '-'}</Descriptions.Item>
                        <Descriptions.Item label="نام کاربری">{referrer.UserName ? strings.getFarsiNum(referrer.UserName) : '-'}</Descriptions.Item>
                    </Descriptions>
                </div>
                : null}
            {data && data.length > 0 ?
                <div className='mt-4'>
                    <div
                        style={{
                            color: 'black',
                            fontWeight: '600',
                            fontSize: '16px',
                            lineHeight: '1.5'
                        }}
                    >افراد معرفی شده</div>
                    <Table
                        style={{ overflowX: 'scroll' }}
                        size="small"
                        className="custom-table crm-request-report"
                        bordered
                        loading={loading}
                        rowKey="Id"
                        scroll={true}
                        dataSource={data}
                        columns={columns}

                    />
                </div>
                : hasReferrer ? null
                    : <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold" }}>گزارش یافت نشد</div>}

        </Spin>
    );
}

export default React.memo(ReferralReport);
